<ng-container *transloco="let t">
  <ng-template #loadingTemplate>
    <div class="flex flex-col items-center">
      <p-progress-spinner />
      <p class="text-xl">{{ t("app.pdfPreview.loading") }}</p>
    </div>
  </ng-template>

  <ng2-pdfjs-viewer
    #pdfViewer
    [showDownload]="true"
    [showOpenFile]="false"
    [showPrint]="false"
    [showViewBookmark]="false"
    [showFullScreen]="false"
    [urlValidation]="false"
    [downloadFileName]="pdfFileName"
    [customSpinnerTpl]="loadingTemplate"
  >
  </ng2-pdfjs-viewer>
</ng-container>
